import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';

import columnDefinitions from './columnDefinitions';
import { getPillDefinitions, Resources } from './viewDiagnostics.constants';
import { DiagnosticsPropTypes } from './propTypes';

class DataGrid extends PureComponent {
  static propTypes = {
    activePill: PropTypes.string.isRequired,
    diagnostics: DiagnosticsPropTypes,
    diagnosticsLoading: PropTypes.bool.isRequired,
  };

  render() {
    const { activePill, diagnostics, diagnosticsLoading } = this.props;
    const columnDefs = columnDefinitions[activePill];

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <AgGrid
          columnDefs={columnDefs}
          rowData={diagnostics && diagnostics[Resources[activePill]]}
          headerHeight={60}
          isGridLoading={diagnosticsLoading}
          withSearchBar
        />
      </div>
    );
  }
}

export default withPillNavigation(getPillDefinitions)(DataGrid);
